<template>
  <div>
    <div class="section-heading">
      <h4>Category</h4>
      <p class="w-70 mt-3">
        Optimize your marketplace strategy by tracking your brand’s performance
        in the right categories and search terms. <br />
        Choose the categories where your products compete and the keywords
        customers use to find them. Weavr will provide in-depth insights to help
        you stay ahead.
      </p>
    </div>
    <p class="platform-heading mt-3">Select Platform</p>
    <multiselect
      @input="changedPlatform"
      label="platform_name"
      track-by="platform_id"
      :value="category.selectedCategoryPlatform"
      class="text-capitalize platform-selector__dropdown"
      :options="selectedPlatforms || []"
      :multiple="false"
      :searchable="false"
      placeholder="Select Platform"
      :showLabels="false"
      :close-on-select="true"
      :allow-empty="false"
    >
    </multiselect>
    <div v-if="category.categoryList.length" class="main-list-section">
      <div class="list-section">
        <h3>Category</h3>
                <div class="tw-h-[470px] tw-overflow-auto">

        <div
          v-for="category in category.categoryList"
          :key="category.key"
          @click="handleCategoryList(category)"
        >
          <div
            :class="[
              'category-list',
              { active: category.key == activeCategoryKey },
            ]"
          >
            <p class="my-3">
              {{ category.value }}
            </p>
            <img src="@/assets/right-arrow.svg" alt="arrow" />
          </div>
        </div>
        </div>
      </div>
      <div class="list-section" v-if="category.subCatList.length">
        <h3 class="text-capitalize">
          {{ category.selectedSubCat.replaceAll("_", " ") }}
        </h3>
                <div class="tw-h-[475px] tw-overflow-auto">

        <div
          v-for="subCat in category.subCatList"
          :key="subCat.key"
          @click="handleSubCategory(subCat)"
        >
          <div
            :class="[
              'category-list',
              { active: subCat.key == activeSubCategoryKey },
            ]"
          >
            <p class="my-3">
              {{ subCat.value }}
            </p>
            <div v-if="subCat.category_id" class="checkbox-btn">
              <input
                type="checkbox"
                @change="handleChildSubCat(subCat)"
                v-model="subCat.is_selected"
                :disabled="subCat.set_diable"
              />
            </div>
            <img
              v-if="!subCat.category_id"
              src="@/assets/right-arrow.svg"
              alt="arrow"
            />
          </div>
          </div>
        </div>
      </div>
      <div
        class="list-section"
        v-if="
          Array.isArray(category.childSubCatList) &&
          category.childSubCatList.length
        "
      >
        <h3 class="text-capitalize">
          {{ category.selectedChildSubCat.replaceAll("_", " ") }}
          <span
            style="
              color: #065559;
              font-size: 14px;
              float: right;
              cursor: pointer;
            "
            @click="handleSelectAllCategory"
            >Select All</span
          >
        </h3>
        <div class="tw-h-[460px] tw-overflow-auto">

        <div v-for="item in category.childSubCatList" :key="item.key">
          <div class="category-list" @click="toggleCheckbox(item)">
            <p class="my-3">
              {{ item.value }}
            </p>
            <div v-if="item.category_id" class="checkbox-btn">
              <input
                type="checkbox"
                @change="handleChildSubCat(item)"
                v-model="item.is_selected"
                :disabled="item.set_diable"
              />
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="onLoading">Loading...</div>
    <div
      v-if="Object.keys(category.selectedCategoryPlatform).length"
      class="selected-category-section"
    >
      <h3>Selected Categories</h3>
      <div class="table-container">
        <table class="platform-table">
          <tr>
            <th>Platforms</th>
            <th>Selected Categories</th>
          </tr>
          <tr
            v-for="platform in selectedPlatforms"
            :key="'platform-' + platform.platform_id"
          >
            <td>
              <div class="tw-flex tw-items-center tw-justify-center tw-gap-2">
                <img
                  :src="getImageUrl(platform.slug)"
                  width="20"
                  :alt="platform.platform_name + ' logo'"
                />
                <span> {{ platform.platform_name }}</span>
              </div>
            </td>
            <td>
              <div class="scroll-container">
                <span
                  v-if="
                    category.finalSelectedCategories[platform.platform_name] &&
                    category.finalSelectedCategories[platform.platform_name]
                      .length
                  "
                >
                  <div
                    v-for="data in category.finalSelectedCategories[
                      platform.platform_name
                    ]"
                    :key="data.key"
                    class="category-badge m-1"
                  >
                    <div
                      class="tw-flex tw-items-center tw-justify-center tw-gap-1"
                    >
                      <span>{{ data.value }}</span>
                      <img
                        src="/Icons_SVG/cross.svg"
                        alt="remove"
                        class="mx-1 cursor-pointer"
                        @click="handleRemoveCategory(platform, data)"
                      />
                    </div>
                  </div>
                </span>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <b-modal
      size="xl"
      class="customModal"
      id="categoryModal"
      v-model="showModal"
      hide-footer
    >
      <template #modal-title>
        <div>
          <h5>Confirm Deletion</h5>
          <p class="modal-desc">
            The categories selected will be deleted from our records. Please
            note that the data for these categories will not be updated any
            further.<br />
            You can still access the past data on the dashboard.
          </p>
        </div>
      </template>
      <div class="selected-category-section">
        <h3>Selected Categories</h3>
        <div class="table-container tw-h-[280px] tw-overflow-auto">
          <table class="platform-table">
            <tr>
              <th>Platforms</th>
              <th>Selected Categories</th>
            </tr>
            <tr
              v-for="platform in selectedPlatforms"
              :key="'platform-' + platform.platform_id"
            >
              <td>
                <div class="tw-flex tw-items-center tw-justify-center tw-gap-2">
                  <img
                    :src="getImageUrl(platform.slug)"
                    width="20"
                    :alt="platform.platform_name + ' logo'"
                  />
                  <span> {{ platform.platform_name }}</span>
                </div>
              </td>
              <td>
                <div class="scroll-container">
                  <span
                    v-if="
                      category.deletedCategory[platform.platform_id] &&
                      category.deletedCategory[platform.platform_id].length
                    "
                  >
                    <div
                      v-for="data in category.deletedCategory[
                        platform.platform_id
                      ]"
                      :key="data.key"
                      class="category-badge m-1"
                    >
                      <div
                        class="tw-flex tw-items-center tw-justify-center tw-gap-1"
                      >
                        <span>{{ data.value }}</span>
                        <img
                          src="/Icons_SVG/cross.svg"
                          alt="remove"
                          class="mx-1 cursor-pointer"
                          @click="handleRestoreDeletedCategory(platform, data)"
                        />
                      </div>
                    </div>
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <button class="primarycolor mt-3 float-right" @click="saveSchedules">
          Confirm
        </button>
      </div>
    </b-modal>
    <div class="save-btn">
      <div class="d-flex">
        <button class="primarycolor mr-3" @click="handleModal">
          Save and Next
        </button>
        <button
          class="navigationButton"
          @click="setSelectedSection(previousSection)"
        >
          Back
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "categoryPage",
  components: {
    Multiselect,
  },
  data() {
    return {
      currentSectionIndex: null,
      nextSection: null,
      previousSection: null,
      finalCategoryArr: [],
      showModal: false,
      category: {
        selectedCategoryPlatform: [],
        categoryList: [],
        selectedSubCat: "",
        subCatList: [],
        selectedChildSubCat: "",
        childSubCatList: [],
        storedCategories: {},
        finalSelectedCategories: {},
        deletedCategory: {},
        activeCategoryKey: "",
        activeSubCategoryKey: "",
      },
    };
  },
  mounted() {
    if (!this.selectedPlatforms.length) {
      this.setDemoLoader(false);
      return;
    }
    this.category.selectedCategoryPlatform = this.selectedPlatforms[0];
    this.selectedPlatforms.forEach((platform) => {
      if (!this.category.finalSelectedCategories[platform.platform_name]) {
        this.$set(
          this.category.finalSelectedCategories,
          platform.platform_name,
          []
        );
      }
    });
    this.setDemoLoader(true);
    Promise.all(
      this.selectedPlatforms.map((platform) =>
        this.getCategoryData(platform.platform_id)
      )
    ).then(() => {
      console
        .log("All platforms processed:", this.category.finalSelectedCategories)
        .catch((error) => {
          console.error("Error fetching category data:", error);
        })
        .finally(() => {
          this.setDemoLoader(false);
        });
    });

    this.currentSectionIndex = this.sections.indexOf(this.selectedSection);
    this.nextSection = this.sections[this.currentSectionIndex + 1];
    this.previousSection = this.sections[this.currentSectionIndex - 1];
  },

  computed: {
    ...mapState("DemoStore", [
      "selectedFeatures",
      "selectedPlatforms",
      "category",
      "sections",
      "selectedSection",
    ]),
  },

  methods: {
    getImageUrl(slug) {
      try {
        return require(`../../../../../public/platform_svg/${slug}.svg`);
      } catch (e) {
        return require("../../../../../public/img/default_platform.png");
      }
    },
    getCategoryData(platformId) {
      return new Promise((resolve, reject) => {
        this.setDemoLoader(true);
        const url = `/api/v3/category_map?platform_id=${platformId}`;

        this.$http
          .get(url)
          .then((response) => {
            const categoryData = response.data.data;
            if (!categoryData || categoryData.length === 0) {
              console.warn(`No category data for platform ${platformId}`);
              this.setDemoLoader(false);
              resolve();
              return;
            }

            const platform = this.selectedPlatforms.find(
              (p) => p.platform_id === platformId
            );

            if (!platform) {
              console.warn("Selected platform not found!");
              this.setDemoLoader(false);
              resolve();
              return;
            }

            const platformName = platform.platform_name;
            if (!platformName) {
              console.warn("Platform name not found!");
              resolve();
              return;
            }

            if (
              this.category.selectedCategoryPlatform.platform_id === platformId
            ) {
              this.category.categoryList = categoryData;
              this.category.selectedSubCat = categoryData[0].key || null;
              this.activeCategoryKey = this.category.selectedSubCat;
              this.category.subCatList =
                categoryData[0][this.category.selectedSubCat] || [];

              if (this.category.subCatList.length > 0) {
                this.category.selectedChildSubCat =
                  this.category.subCatList[0].key || null;
                this.activeSubCategoryKey = this.category.selectedChildSubCat;
                this.category.childSubCatList =
                  this.category.subCatList[0][
                    this.category.selectedChildSubCat
                  ] || [];
              }
            }

            this.category.storedCategories[platformId] = categoryData;

            if (!this.category.finalSelectedCategories[platformName]) {
              this.$set(
                this.category.finalSelectedCategories,
                platformName,
                []
              );
            }

            const uniqueSet = new Set(
              this.category.finalSelectedCategories[platformName].map((item) =>
                JSON.stringify(item)
              )
            );
            categoryData.forEach((category) => {
              const selectedSubCat = category.key;
              const subCatList = category[selectedSubCat] || [];

              subCatList.forEach((subCat) => {
                const selectedChildSubCat = subCat.key;
                const childSubCatList = subCat[selectedChildSubCat] || [];

                [...subCatList, ...childSubCatList].forEach((data) => {
                  if (
                    data.set_diable === true &&
                    !uniqueSet.has(JSON.stringify(data))
                  ) {
                    uniqueSet.add(JSON.stringify(data));
                    this.category.finalSelectedCategories[platformName].push(
                      data
                    );
                  }
                });
              });
            });

            resolve();
            this.setDemoLoader(false);
          })
          .catch((error) => {
            console.error("Error fetching category data:", error);
            this.setDemoLoader(false);
            reject(error);
          });
      });
    },
    ...mapActions("DemoStore", [
      "setDemoLoader",
      "setSelectedSection",
      "setTotalPlatforms",
      "setSelectedPlatforms",
      "setSelectedCategoryPlatforms",
    ]),
    toggleCheckbox(item) {
      if (item.set_diable) return;
      item.is_selected = !item.is_selected;
      this.handleChildSubCat(item);
    },
    changedPlatform(value) {
      this.setSelectedCategoryPlatforms(value);
      this.category.selectedCategoryPlatform = value;
      const platformId = value.platform_id;
      if (this.category.storedCategories[platformId]) {
        this.category.categoryList = this.category.storedCategories[platformId];
        this.category.selectedSubCat = this.category.categoryList[0].key;
        this.category.subCatList =
          this.category.categoryList[0][this.category.selectedSubCat];
        this.category.selectedChildSubCat = this.category.subCatList[0].key;
        this.category.childSubCatList =
          this.category.subCatList[0][this.category.selectedChildSubCat];
      }
    },

    handleCategoryList(category) {
      this.activeCategoryKey = category.key;
      this.category.selectedSubCat = category.key;
      const selectedCategory = this.category.categoryList.find(
        (data) => data.key === category.key
      );

      if (selectedCategory) {
        this.category.subCatList =
          selectedCategory[this.category.selectedSubCat];
        if (
          Array.isArray(this.category.subCatList) &&
          this.category.subCatList.length
        ) {
          this.category.selectedChildSubCat = this.category.subCatList[0].key;
          this.activeSubCategoryKey = this.category.selectedChildSubCat;
          this.category.childSubCatList =
            selectedCategory[this.category.selectedSubCat][0][
              this.category.selectedChildSubCat
            ];
        } else {
          this.category.childSubCatList = [];
          this.category.selectedChildSubCat = "";
        }
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    handleSubCategory(subCat) {
      this.activeSubCategoryKey = subCat.key;
      this.category.selectedChildSubCat = subCat.key;
      const selectedSubCategory = this.category.subCatList.find(
        (data) => data.key === subCat.key
      );
      if (selectedSubCategory) {
        this.category.childSubCatList = selectedSubCategory[subCat.key];
      }
    },
    handleChildSubCat(subcat) {
      const platform = this.category.selectedCategoryPlatform;
      const platformName = platform.platform_name;

      if (!Array.isArray(this.category.finalSelectedCategories[platformName])) {
        this.category.finalSelectedCategories[platformName] = [];
      }

      if (subcat.is_selected) {
        if (
          !this.finalCategoryArr.some(
            (item) =>
              item.platform_id === platform.platform_id &&
              item.key === subcat.key
          )
        ) {
          this.finalCategoryArr.push({
            platform_id: platform.platform_id,
            category_id: subcat.category_id,
            key: subcat.key,
            link: subcat.link,
            source: "childSubCat",
          });
        }

        if (
          !this.category.finalSelectedCategories[platformName].some(
            (item) => item.key === subcat.key
          )
        ) {
          this.category.finalSelectedCategories[platformName].push(subcat);
        }
      } else {
        this.finalCategoryArr = this.finalCategoryArr.filter(
          (item) =>
            !(
              item.platform_id === platform.platform_id &&
              item.key === subcat.key &&
              item.source === "childSubCat"
            )
        );

        this.category.finalSelectedCategories[platformName] =
          this.category.finalSelectedCategories[platformName].filter(
            (item) => item.key !== subcat.key
          );
      }
    },

    handleSelectAllCategory() {
      const platform = this.category.selectedCategoryPlatform;
      const platformName = platform.platform_name;

      if (!Array.isArray(this.category.finalSelectedCategories[platformName])) {
        this.category.finalSelectedCategories[platformName] = [];
      }

      const allSelected = this.category.childSubCatList.every(
        (item) => item.is_selected || item.set_diable
      );
      if (allSelected) {
        this.category.finalSelectedCategories[platformName] =
          this.category.finalSelectedCategories[platformName].filter(
            (item) => item.source !== "selectAll"
          );

        this.category.childSubCatList.forEach((item) => {
          if (!item.set_diable) {
            item.is_selected = false;
          }
        });

        this.finalCategoryArr = this.finalCategoryArr.filter(
          (item) =>
            !(
              item.platform_id === platform.platform_id &&
              item.source === "selectAll"
            )
        );
      } else {
        const unselectedItems = this.category.childSubCatList.filter(
          (item) => !item.is_selected && !item.set_diable
        );

        // Push to finalSelectedCategories
        unselectedItems.forEach((item) => {
          item.is_selected = true;
          this.category.finalSelectedCategories[platformName].push({
            ...item,
            source: "selectAll",
          });
        });

        const newItems = unselectedItems.map((item) => ({
          platform_id: platform.platform_id,
          category_id: item.category_id,
          key: item.key,
          link: item.link,
          source: "selectAll",
        }));

        const uniqueItems = [...this.finalCategoryArr, ...newItems].filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) => t.platform_id === item.platform_id && t.key === item.key
            )
        );

        this.finalCategoryArr = uniqueItems;
      }
    },

    handleRemoveCategory(platform, data) {
      if (!this.category.deletedCategory[platform.platform_id]) {
        this.$set(this.category.deletedCategory, platform.platform_id, []);
      }
      if (data.set_diable) {
        const updatedData = { ...data, platform_id: platform.platform_id };
        this.category.deletedCategory[platform.platform_id].push(updatedData);
      }

      if (this.category.finalSelectedCategories) {
        Object.keys(this.category.finalSelectedCategories).forEach(
          (platform) => {
            if (
              Array.isArray(this.category.finalSelectedCategories[platform])
            ) {
              this.category.finalSelectedCategories[platform] =
                this.category.finalSelectedCategories[platform].filter(
                  (item) => item.category_id !== data.category_id
                );
            }
          }
        );
      }

      if (Array.isArray(this.category.childSubCatList)) {
        this.category.childSubCatList.forEach((item) => {
          if (item.category_id === data.category_id) {
            item.is_selected = false;
          }
        });
      }

      if (Array.isArray(this.category.subCatList)) {
        this.category.subCatList.forEach((subCat) => {
          if (subCat.category_id === data.category_id) {
            subCat.is_selected = false;
          }
        });
      }

      if (Array.isArray(this.finalCategoryArr)) {
        this.finalCategoryArr = this.finalCategoryArr.filter(
          (item) => item.category_id !== data.category_id
        );
      }
      this.$forceUpdate();
    },
    handleModal() {
      if (Object.values(this.category.deletedCategory).length) {
        this.showModal = true;
      } else {
        this.saveSchedules();
      }
    },
    async handleConfirmDelete() {
      this.setDemoLoader(true);
      const url = "api/v3/category_map";
      const user = localStorage.getItem("reviewUserData");
      const token = JSON.parse(user);
      const payload = [];
      Object.keys(this.category.deletedCategory).forEach((platformId) => {
        this.category.deletedCategory[platformId].forEach((item) => {
          payload.push({
            platform_id: platformId,
            category_id: item.category_id,
            key: item.key,
            link: item.link,
          });
        });
      });
      if (payload.length === 0) {
        console.warn("Payload is empty, skipping API call.");
        return;
      }

      try {
        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            TOKEN: token.data.token,
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
      } catch (err) {
        console.error("Error:", err);
      } finally {
        this.setDemoLoader(false);
      }
    },
    handleRestoreDeletedCategory(platform, data) {
      const platformId = data.platform_id;
      const platformName = platform.platform_name;

      if (this.category.deletedCategory[platformId]) {
        const index = this.category.deletedCategory[platformId].findIndex(
          (item) => item.category_id === data.category_id
        );

        if (index !== -1) {
          const restoredData = this.category.deletedCategory[platformId][index];
          if (!this.category.finalSelectedCategories[platformName]) {
            this.$set(this.category.finalSelectedCategories, platformName, []);
          }
          this.category.finalSelectedCategories[platformName].push(
            restoredData
          );
          if (Array.isArray(this.category.childSubCatList)) {
            this.category.childSubCatList.forEach((item) => {
              if (item.category_id === restoredData.category_id) {
                item.is_selected = true;
              }
            });
          }
          if (Array.isArray(this.category.subCatList)) {
            this.category.subCatList.forEach((subCat) => {
              if (subCat.category_id === restoredData.category_id) {
                subCat.is_selected = true;
              }
            });
          }
          this.category.deletedCategory[platformId].splice(index, 1);
          if (this.category.deletedCategory[platformId].length === 0) {
            this.$delete(this.category.deletedCategory, platformId);
          }
          this.$forceUpdate();
        }
      }
    },
    saveSchedules() {
      this.setDemoLoader(true);
      if (Object.keys(this.category.deletedCategory).length) {
        this.handleConfirmDelete();
      }
      const url = "api/v3/category_map";
      const payload = {
        data: this.finalCategoryArr.map(({ source, ...rest }) => rest),
      };
      this.$http
        .put(url, payload)
        .then((res) => {
          this.setSelectedSection(this.nextSection);
          this.setDemoLoader(false);
        })
        .catch((err) => {
          console.error(err);
          this.setDemoLoader(false);
        });
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.section-heading h4 {
  font-size: 18px;
  font-weight: 600;
}
.section-heading p {
  color: #5e5e5e;
  font-size: 14px;
  font-weight: 500;
}
.platform-heading {
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}
.platform-selector__dropdown {
  width: 230px;
}
.main-list-section {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 32px;
}
.list-section {
  width: 464px;
  height: 540px;
  /* overflow: auto; */
  border: 1px solid #d5d5d5;
  border-radius: 3px;
  margin-top: 16px;
  padding-bottom: 16px;
}
@media screen and ((min-width: 1384px ) and (max-width: 1715px)) {
  .list-section {
    width: 31.9%;
  }
}
@media screen and (max-width: 1384px) {
  .list-section {
    width: 31.7%;
  }
}
.list-section > h3 {
  font-weight: 600;
  font-size: 16px;
  background: rgba(6, 85, 89, 0.1);
  padding: 16px;
}
.list-section > div:hover {
  background: rgba(161, 161, 161, 0.1);
}
.checkbox-btn {
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  border-radius: 2px;
}

.checkbox-btn input {
  width: 16px;
  height: 16px;
  accent-color: #065559;
}

.selected-category-section > h3 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  margin: 16px 0;
}
.platform-table {
  width: 100%;
  max-width: 1440px;
  border-collapse: collapse;
}

.platform-table th {
  background: rgba(6, 85, 89, 0.1);
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  padding: 14px;
  border-collapse: collapse;
  border: 1px solid #d5d5d5;
}

.platform-table td {
  padding: 16px;
  text-align: left;
  font-size: 14px;
  white-space: nowrap;
  border-collapse: collapse;
  border: 1px solid #d5d5d5;
}

.platform-table td:first-child {
  width: 500px;
  white-space: nowrap;
  text-align: center;
}

.platform-table td:last-child {
  max-width: 340px;
  overflow-x: auto;
  white-space: nowrap;
}
.platform-table tbody td {
  border: none !important;
}

.table-container {
  overflow: hidden;
  max-width: 1440px;
  border-radius: 3px;
}

.scroll-container {
  max-width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}

.category-badge {
  border: 1px solid rgba(174, 174, 174, 1);
  border-radius: 20px;
  padding: 8px 12px;
  display: inline-block;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #949292 #ffffff;
}

*::-webkit-scrollbar {
  width: 0px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #949292 #ffffff;
  border-radius: 10px;
  border: 1px solid #ffffff;
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins", sans-serif;
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.navigationButton:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

button.primarycolor {
  height: 35px;
  border: none !important;
  margin: 0;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

button.primarycolor:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.save-btn {
  margin-top: 151px;
}
.customModal {
  overflow: auto;
  max-width: 200px;
}
.onLoading {
  font-weight: 600;
  font-size: 16px;
  background: #f0eded;
  padding: 12px;
  border-radius: 10px;
  margin: 10px 3px;
}
.category-list {
  margin: 0px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: #505050;
  border-bottom: 1px solid rgba(213, 213, 213, 1);
}

.category-list.active {
  background-color: rgba(161, 161, 161, 0.1);
  font-weight: 600;
  color: #050a13;
  margin: 0;
  padding: 0px 16px;
}
</style>
<style>
#categoryModal .modal-header {
  padding-bottom: 0 !important;
}
#categoryModal .modal-title {
  color: #00555a !important;
  font-weight: 500;
  font-size: 16px !important;
  font-family: "poppins", sans-serif !important;
  padding-bottom: 0 !important;
}
#categoryModal .modal-desc {
  font-size: 14px !important;
  font-weight: 400 !important;
  font-family: "poppins", sans-serif;
  line-height: 20px !important;
  color: #505050 !important;
  margin-top: 12px !important;
}
#categoryModal .modal-dialog {
  margin-top: 200px !important;
}
</style>
